import * as React from 'react'

function SvgFirstAidKitChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="M33.707 9.707 28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293 1.414 1.414Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11c0-.338.019-.672.055-1H17a2 2 0 0 0-2 2v2h-4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-8.223A9.033 9.033 0 0 1 29 20v8h-2v-8.223a8.94 8.94 0 0 1-2-.713V28H15V16h6.515a8.968 8.968 0 0 1-1.003-2H17v-2h3.055A9.098 9.098 0 0 1 20 11Zm-7 5h-2v12h2V16Z"
      />
      <path d="M19 19v2h-2v2h2v2h2v-2h2v-2h-2v-2h-2Z" />
    </svg>
  )
}

export default SvgFirstAidKitChecked
